// This file is automatically generated. Do not edit manually.

import { CatalogPartRevisionView } from "src/api/generated/erp/db/types/tables/catalogPartRevisionView";
import { CatalogPartView } from "src/api/generated/erp/db/types/tables/catalogPartView";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CopyCatalogPartRevisionContentFormApi {
	export async function getFormInitData(args: {
		catalogPartId: number;
	}): Promise<CopyCatalogPartRevisionContentFormApi_FormInitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productManagement/catalogPartRevision/copyContent/getFormInitData",
			method: "POST",
			data: {
				catalogPartId: args.catalogPartId,
			},
		});
		return response as CopyCatalogPartRevisionContentFormApi_FormInitData;
	}

	export async function getSourceRevisionOptions(args: {
		sourceCatalogPartId: number;
		targetRevisionId: number;
	}): Promise<Array<CatalogPartRevisionView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productManagement/catalogPartRevision/copyContent/getSourceRevisionOptions",
			method: "POST",
			data: {
				sourceCatalogPartId: args.sourceCatalogPartId,
				targetRevisionId: args.targetRevisionId,
			},
		});
		return response as Array<CatalogPartRevisionView>;
	}

	export async function submit(args: {
		targetPartRevisionId: number;
		sourcePartRevisionId: number;
		copyBom: boolean;
		copyDocuments: boolean;
		copyConfigurator: boolean;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productManagement/catalogPartRevision/copyContent/submit",
			method: "POST",
			data: {
				targetPartRevisionId: args.targetPartRevisionId,
				sourcePartRevisionId: args.sourcePartRevisionId,
				copyBom: args.copyBom,
				copyDocuments: args.copyDocuments,
				copyConfigurator: args.copyConfigurator,
			},
		});
		return response as void;
	}
}

export interface CopyCatalogPartRevisionContentFormApi_FormInitData {
	activeRevision: CatalogPartRevisionView | null | undefined;
	targetCatalogPart: CatalogPartView;
}
